import Dexie, { Table } from "dexie";
import { DeserializedBrokerDeal } from "../../model/BrokerDeal";

interface CachedBrokerDealsData {
  id: number;
  data: DeserializedBrokerDeal[];
  cachedAt: Date;
}

class CachedBrokerDealsDexie extends Dexie {
  cachedBrokerDealsData: Table<CachedBrokerDealsData, number>;

  constructor() {
    super("BrokerDealsDashboard");
    this.version(1).stores({ cachedBrokerDealsData: "++id" });
    this.cachedBrokerDealsData = this.table("cachedBrokerDealsData");
  }
}

const dexieDatabase = new CachedBrokerDealsDexie();

export const getCachedBrokerDealsData = async () => {
  const payload = await dexieDatabase.cachedBrokerDealsData.get(1);

  if (!payload) {
    return null;
  }

  const cachedAt = payload.cachedAt;

  const today = new Date();
  const cacheDateIsToday = today.getDate() === cachedAt.getDate() && today.getMonth() === cachedAt.getMonth() && today.getFullYear() === cachedAt.getFullYear();
  if (cacheDateIsToday) {
    return payload.data;
  }

  return null;
};

export const cacheBrokerDealsData = async (data: DeserializedBrokerDeal[]) => {
  const cachedAt = new Date();
  const payload: CachedBrokerDealsData = { id: 1, data, cachedAt };
  await dexieDatabase.cachedBrokerDealsData.put(payload);
};

export const clearCachedBrokerDealsData = async () => {
  await dexieDatabase.cachedBrokerDealsData.delete(1);
};
